/* The Load-Out Check on the Visits tile (decision 9140): its own block, set off from the visits above and the tile's buttons below. */
.check {
  display: grid;
  gap: var(--space-2);
  margin-block: var(--space-4);
}

.lines {
  display: grid;
  gap: var(--space-3);
  margin: 0;
  padding: 0;
  list-style: none;
}

.line {
  display: grid;
  gap: var(--space-1);
}

.answer {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--space-2);
}
